import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/index';
import { FormProvider } from 'react-hook-form';
import { ExtendedUseFormReturn } from '@Hooks/index';
import { BusinessAddressForm } from './businessAddressForm/BusinessAddressForm';
import { useBusinessAddressLogic } from './hooks/useBusinessAddress';
import { IBusinessAddressForm } from './businessAddressForm/businessAddressSchema';

export const BusinessAddress = () => {
  const { t } = useTranslation();
  const { formMethods, handleSubmit, isPending, defaultValues } = useBusinessAddressLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        isLoading={isPending}
        heading={t('pages.businessAddress.title')}
        content={t('pages.businessAddress.subTitle')}>
        <div className='form-provider-base'>
          <BusinessAddressForm
            formMethods={formMethods as ExtendedUseFormReturn<IBusinessAddressForm>}
            defaultValues={defaultValues}
          />
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
